module.exports = __webpack_public_path__ + "public/images/slider/oleynikova-circle.b08a94d9d401136777a54354f9dc5c2c.webp";